import { render, staticRenderFns } from "./VersionItem.vue?vue&type=template&id=582334fd"
import script from "./VersionItem.vue?vue&type=script&lang=js"
export * from "./VersionItem.vue?vue&type=script&lang=js"
import style0 from "./VersionItem.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports